<div class="container-fluid ey-body-bg">
  <!--Content-->
  <div class="ey-content mt-3">
    <div class="col-sm-12">
      <h1 class="tp-benchmark">TP Benchmark</h1>
      <p class="your-are-currently-s" innerHTML="{{ logoutMessage }}"></p>
      <button (click)="login()" class="btn btn-default">Sign back in</button>
    </div>
  </div>
  <!--Content-->
</div>
